<template>
    <div>
        <div class="tab-card">

            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                    <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>

                    <keep-alive v-if="!loading">
                        <component :is="currentView" :detail="detail"></component>
                    </keep-alive>
                    
                </el-tab-pane>
            </el-tabs>

        </div>
    </div>
</template>

<script>
import services from '../serve.services'

import detailForm from './detailForm.vue' // 合同信息
import serviceArea from './serviceArea.vue' // 服务范围
import serviceItem from './serviceItem.vue' // 服务项
import linkman from './linkman.vue' // 联系人
import document from './document.vue' // 文件
export default {

    props: {
        serialNumber: String
    },

    data() {
        return {
            detail:{},
            eventList:[],
            index:0,
            loading:true,
            activeName:"detailForm",
            tabViews:[
                { name:"合同信息",index:"detailForm"},
                { name:"服务范围",index:"serviceArea"},
                { name:"服务项",index:"serviceItem"},
                { name:"联系人",index:"linkman"},
                { name:"文件",index:"document"}
            ]
        }
    },

    created() {
        this.getDetail()
    },

    components: { detailForm, serviceArea, serviceItem, linkman, document},

    computed:{
        currentView(){
            return this.tabViews[this.index].index
        },
    },

    methods: {

        // 获取列表
        getDetail() {
            services.contractDescribe({ serialNumber: this.serialNumber})
                .then(res => this.detail =  res)
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },

        // 设置组件索引
        handleClick(tab, event) {
            this.index = tab.index
        }
    }
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>

